export const SHOW_SNACKBAR = 'SHOW_SNACKBAR'

export const showSnackbar = snackbarOptions => ({
  type: SHOW_SNACKBAR,
  snackbarOptions
})
